const BASE_URL =
  import.meta.env.VITE_SSE_URL || "https://anna-chat-dev.pretorianhackers.com";

async function current() {
  const token = localStorage.getItem("anna_token");
  const response = await fetch(`${BASE_URL}/irene-live`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.detail || payload.error || `HTTP ${response.status}`);
  }
  return payload;
}

export const ireneLiveApi = { current };
